import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../../helpers/visibility'

export default class extends Controller {
  static targets = [
    "actionDropdown",
    "bulkEditButton", 
    "buttonText",
    "checkbox",
    "eventTypeIds",
    "eventTypeRow",
    "selectAllCheckbox",
    "serviceCheckbox",
    "groupCheckbox",
    "moveToGroupWrapper",
    "updateStatusWrapper",
    "updateSchedulingWrapper",
    "dateModeDropdown",
    "calendarModeWrapper",
    "updateAvailabilityWrapper",
    "availabilityDropdown",
    "availabilityTimeWrapper",
    "dayOfWeekWrapper",
    "updateDepositWrapper",
    "depositMethodDropdown",
    "depositAmountWrapper",
    "depositPercentWrapper",
    "deleteWarningWrapper",
    "updatePricingWrapper",
    "setStartingRateDropdown", 
    "startingRateWrapper",
    "extraHoursDropdown",
    "extraHoursFieldsWrapper",
    "updateAdvancedWrapper",
    "onlineBookingModeDropdown",
    "contactFormWrapper",
    "requiresLeadTimeDropdown",
    "leadTimeDaysWrapper",
    "hasPhotoboothBackgroundDropdown",
    "allowSkipBackdropWrapper"
  ]

  connect() {
    this.updateCheckboxes()
    this.refreshVisibility()
  }

  refreshVisibility() {
    if(!this.hasActionDropdownTarget) return
    
    const action = this.actionDropdownTarget.value
    this.hideAllWrappers()
    switch(action) {
      case "move_to_group":
        if(this.hasMoveToGroupWrapperTarget) {
          showTarget(this.moveToGroupWrapperTarget)
        }
        break;
      case "update_status":
        if(this.hasUpdateStatusWrapperTarget) {
          showTarget(this.updateStatusWrapperTarget)
        }
        break;
      case "update_scheduling_mode":
        if(this.hasUpdateSchedulingWrapperTarget) {
          showTarget(this.updateSchedulingWrapperTarget)
        }

        const dateMode = this.dateModeDropdownTargets.find(option => option.checked).value
        console.log({ dateMode })
        if(dateMode === "date_time") {
          showTarget(this.calendarModeWrapperTarget)
        } else {
          hideTarget(this.calendarModeWrapperTarget)
        }

        break;
      case "update_availability":
        if(this.hasUpdateAvailabilityWrapperTarget) {
          showTarget(this.updateAvailabilityWrapperTarget)
        }
        this.refreshAvailabilityTimeFields()
        break;
      case "update_deposit":
        if(this.hasUpdateDepositWrapperTarget) {
          showTarget(this.updateDepositWrapperTarget)
        }
        this.refreshDepositFields()
        break;
      case "update_pricing":
        if(this.hasUpdatePricingWrapperTarget) {
          showTarget(this.updatePricingWrapperTarget)
        }
        this.refreshPricingFields()
        break;
      case "update_advanced":
        console.log("Advanced action selected, hasTarget:", this.hasUpdateAdvancedWrapperTarget)
        if(this.hasUpdateAdvancedWrapperTarget) {
          showTarget(this.updateAdvancedWrapperTarget)
        }
        this.refreshAdvancedFields()
        break;
      case "delete":
        if(this.hasDeleteWarningWrapperTarget) {
          showTarget(this.deleteWarningWrapperTarget)
        }
        break;
      default:
        console.warn(`Unhandled action: ${action}`)
    }
  }

  updateCheckboxes() {
    const checked = this.checkboxTargets.filter(checkbox => checkbox.checked)
    const unchecked = this.checkboxTargets.filter(checkbox => !checkbox.checked)

    if(checked.length > 0) {
      showTarget(this.bulkEditButtonTarget)
      // Update button text with count
      if(this.hasButtonTextTarget) {
        this.buttonTextTarget.textContent = `Edit Selected Packages (${checked.length})`
      }
    }
    else {
      hideTarget(this.bulkEditButtonTarget)
    }

    if(this.hasEventTypeIdsTarget) {
      this.eventTypeIdsTarget.value = checked.map(checkbox => checkbox.value).join(",")
    }
    
    // Update select all checkbox state
    if(this.hasSelectAllCheckboxTarget) {
      if(checked.length === this.checkboxTargets.length && checked.length > 0) {
        this.selectAllCheckboxTarget.checked = true
        this.selectAllCheckboxTarget.indeterminate = false
      } else if(checked.length > 0) {
        this.selectAllCheckboxTarget.checked = false
        this.selectAllCheckboxTarget.indeterminate = true
      } else {
        this.selectAllCheckboxTarget.checked = false
        this.selectAllCheckboxTarget.indeterminate = false
      }
    }
    
    // Update service and group checkbox states
    this.updateServiceCheckboxStates()
    this.updateGroupCheckboxStates()
  }

  toggleSelectAll() {
    if(this.selectAllCheckboxTarget.checked) {
      this.checkboxTargets.forEach(checkbox => {
        checkbox.checked = true
      })
    }
    else {
      this.checkboxTargets.forEach(checkbox => {
        checkbox.checked = false
      })
    }
    this.updateCheckboxes()
  }

  hideAllWrappers() {
    if(this.hasMoveToGroupWrapperTarget) hideTarget(this.moveToGroupWrapperTarget)
    if(this.hasUpdateStatusWrapperTarget) hideTarget(this.updateStatusWrapperTarget)
    if(this.hasUpdateSchedulingWrapperTarget) hideTarget(this.updateSchedulingWrapperTarget)
    if(this.hasUpdateAvailabilityWrapperTarget) hideTarget(this.updateAvailabilityWrapperTarget)
    if(this.hasUpdateDepositWrapperTarget) hideTarget(this.updateDepositWrapperTarget)
    if(this.hasDeleteWarningWrapperTarget) hideTarget(this.deleteWarningWrapperTarget)
    if(this.hasUpdatePricingWrapperTarget) hideTarget(this.updatePricingWrapperTarget)
    if(this.hasUpdateAdvancedWrapperTarget) hideTarget(this.updateAdvancedWrapperTarget)
  }
  
  refreshAvailabilityTimeFields() {
    if(!this.hasAvailabilityDropdownTarget) return
    
    const availability = this.availabilityDropdownTargets.find(option => option.checked)?.value
    
    if(availability === "yes_certain_hours") {
      if(this.hasAvailabilityTimeWrapperTarget) {
        showTarget(this.availabilityTimeWrapperTarget)
      }
      if(this.hasDayOfWeekWrapperTarget) {
        hideTarget(this.dayOfWeekWrapperTarget)
      }
    } else if(availability === "no") {
      if(this.hasAvailabilityTimeWrapperTarget) {
        hideTarget(this.availabilityTimeWrapperTarget)
      }
      if(this.hasDayOfWeekWrapperTarget) {
        showTarget(this.dayOfWeekWrapperTarget)
      }
    } else {
      if(this.hasAvailabilityTimeWrapperTarget) {
        hideTarget(this.availabilityTimeWrapperTarget)
      }
      if(this.hasDayOfWeekWrapperTarget) {
        hideTarget(this.dayOfWeekWrapperTarget)
      }
    }
  }
  
  refreshDepositFields() {
    if(!this.hasDepositMethodDropdownTarget) return
    
    const depositMethod = this.depositMethodDropdownTargets.find(option => option.checked)?.value
    
    if(depositMethod === "flat_rate") {
      if(this.hasDepositAmountWrapperTarget) {
        showTarget(this.depositAmountWrapperTarget)
      }
      if(this.hasDepositPercentWrapperTarget) {
        hideTarget(this.depositPercentWrapperTarget)
      }
    } else if(depositMethod === "percent") {
      if(this.hasDepositAmountWrapperTarget) {
        hideTarget(this.depositAmountWrapperTarget)
      }
      if(this.hasDepositPercentWrapperTarget) {
        showTarget(this.depositPercentWrapperTarget)
      }
    } else {
      if(this.hasDepositAmountWrapperTarget) {
        hideTarget(this.depositAmountWrapperTarget)
      }
      if(this.hasDepositPercentWrapperTarget) {
        hideTarget(this.depositPercentWrapperTarget)
      }
    }
  }
  
  refreshAdvancedFields() {
    // Show contact form field if online_booking_mode is show_contact_form
    if(this.hasOnlineBookingModeDropdownTarget && this.hasContactFormWrapperTarget) {
      const onlineBookingMode = this.onlineBookingModeDropdownTargets.find(option => option.checked)?.value
      if(onlineBookingMode === "show_contact_form") {
        showTarget(this.contactFormWrapperTarget)
      } else {
        hideTarget(this.contactFormWrapperTarget)
      }
    }
    
    // Show lead time days field if requires_lead_time is true
    if(this.hasRequiresLeadTimeDropdownTarget && this.hasLeadTimeDaysWrapperTarget) {
      const requiresLeadTime = this.requiresLeadTimeDropdownTargets.find(option => option.checked)?.value
      if(requiresLeadTime === "true") {
        showTarget(this.leadTimeDaysWrapperTarget)
      } else {
        hideTarget(this.leadTimeDaysWrapperTarget)
      }
    }
    
    // Show backdrop skip option if has_photobooth_background is true
    if(this.hasHasPhotoboothBackgroundDropdownTarget && this.hasAllowSkipBackdropWrapperTarget) {
      const hasPhotoboothBackground = this.hasPhotoboothBackgroundDropdownTargets.find(option => option.checked)?.value
      if(hasPhotoboothBackground === "true") {
        showTarget(this.allowSkipBackdropWrapperTarget)
      } else {
        hideTarget(this.allowSkipBackdropWrapperTarget)
      }
    }
  }
  
  refreshPricingFields() {
    // Show starting rate fields if set_starting_rate is true
    if(this.hasSetStartingRateDropdownTarget && this.hasStartingRateWrapperTarget) {
      const setStartingRate = this.setStartingRateDropdownTargets.find(option => option.checked)?.value
      if(setStartingRate === "true") {
        showTarget(this.startingRateWrapperTargets)
      } else {
        hideTarget(this.startingRateWrapperTargets)
      }
    }
    
    // Show extra hours fields if enable_customer_can_book_extra_hours is true
    if(this.hasExtraHoursDropdownTarget && this.hasExtraHoursFieldsWrapperTarget) {
      const enableExtraHours = this.extraHoursDropdownTargets.find(option => option.checked)?.value
      if(enableExtraHours === "true") {
        showTarget(this.extraHoursFieldsWrapperTargets)
      } else {
        hideTarget(this.extraHoursFieldsWrapperTargets)
      }
    }
  }
  
  toggleServiceSelection(event) {
    const serviceCheckbox = event.target
    const serviceId = serviceCheckbox.dataset.serviceId
    const isChecked = serviceCheckbox.checked
    
    // Find all checkboxes for packages in this service
    const packagesInService = this.getPackagesInService(serviceId)
    
    // Update all checkboxes in this service
    packagesInService.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    
    // Update the overall state
    this.updateCheckboxes()
  }

  toggleGroupSelection(event) {
    const groupCheckbox = event.target
    const groupId = groupCheckbox.dataset.groupId
    const isChecked = groupCheckbox.checked
    
    // Find all checkboxes for packages in this group
    const packagesInGroup = this.getPackagesInGroup(groupId)
    
    // Update all checkboxes in this group
    packagesInGroup.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    
    // Update the overall state
    this.updateCheckboxes()
  }
  
  getPackagesInService(serviceId) {
    return this.checkboxTargets.filter(checkbox => 
      checkbox.dataset.serviceId === serviceId
    )
  }

  getPackagesInGroup(groupId) {
    return this.checkboxTargets.filter(checkbox => 
      checkbox.dataset.groupId === groupId
    )
  }
  
  updateServiceCheckboxStates() {
    this.serviceCheckboxTargets.forEach(serviceCheckbox => {
      const serviceId = serviceCheckbox.dataset.serviceId
      const packagesInService = this.getPackagesInService(serviceId)
      const checkedCount = packagesInService.filter(cb => cb.checked).length
      
      if (checkedCount === 0) {
        serviceCheckbox.checked = false
        serviceCheckbox.indeterminate = false
      } else if (checkedCount === packagesInService.length) {
        serviceCheckbox.checked = true
        serviceCheckbox.indeterminate = false
      } else {
        serviceCheckbox.checked = false
        serviceCheckbox.indeterminate = true
      }
    })
  }

  updateGroupCheckboxStates() {
    this.groupCheckboxTargets.forEach(groupCheckbox => {
      const groupId = groupCheckbox.dataset.groupId
      const packagesInGroup = this.getPackagesInGroup(groupId)
      const checkedCount = packagesInGroup.filter(cb => cb.checked).length
      
      if (checkedCount === 0) {
        groupCheckbox.checked = false
        groupCheckbox.indeterminate = false
      } else if (checkedCount === packagesInGroup.length) {
        groupCheckbox.checked = true
        groupCheckbox.indeterminate = false
      } else {
        groupCheckbox.checked = false
        groupCheckbox.indeterminate = true
      }
    })
  }
}
